// from https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i['return']) _i['return']();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError('Invalid attempt to destructure non-iterable instance');
    }
  };
}();

exports['default'] = parseUnit;
exports.parseUnitObj = parseUnitObj;
var NUMBER_REGEX = /-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/;

function parseUnit(str) {
  // parse the number at the start of the string (this could return it in exponential notation)
  var val = parseFloat(str); // this is the actual number string,
  // might not be the same length as val if val is in exponential notation

  var numberStrings = str.match(NUMBER_REGEX) || []; // get everything after this number

  var unit = numberStrings.length > 0 ? str.substr(numberStrings[0].length).trim() : '';
  return [val, unit];
}

function parseUnitObj(str) {
  var _parseUnit = parseUnit(str);

  var _parseUnit2 = _slicedToArray(_parseUnit, 2);

  var val = _parseUnit2[0];
  var unit = _parseUnit2[1];
  return {
    val: val,
    unit: unit
  };
}